import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { OnInit, Component, Input, Inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { SnackService } from 'src/app/services/snack.service';
import { RequestService } from 'src/app/services/request.service';

@Component({
  selector: 'reset-quotation-sent',
  templateUrl: './reset-quotation-sent.component.html',
  styleUrls: ['./reset-quotation-sent.component.scss'],
})
export class ResetQuotationSentComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  subProjectId: number;

  @Input()
  reason: string;

  constructor(
    public dialogRef: MatDialogRef<ResetQuotationSentComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private requestService: RequestService,
    private snackService: SnackService
  ) {
    super();
    this.subProjectId = data.subProjectId;
    this.reason = data.reason;
  }

  ngOnInit() {}

  reasonChange(reason: string) {
    this.reason = reason;
  }

  closeDialog() {
    this.dialogRef.close(null);
  }

  resetQuotationSent() {
    if (this.reason == null || this.reason.length === 0) {
      this.snackService.showWarning(
        'Gelieve een reden op te geven voor de reset'
      );
      return;
    }
    const body = {
      id: this.subProjectId,
      reason: this.reason,
    };
    this.addSubscription(
      this.requestService.post(body, '/subprojects/resetQuotationSent'),
      (res) => {
        if (res.success) {
          this.snackService.showSuccess('Offerte verstuurd succesvol gereset');
          this.dialogRef.close(this.reason);
        } else {
          this.snackService.showError(
            'Kon offerte verstuurd niet resetten: ' + res.message
          );
        }
      }
    );
  }
}
